import styled from '@emotion/styled';

export const ContainerWrapper = styled.div`
  padding: 5% 30%;
  text-align: center;
`;
